// src/components/job-engine/JobEngineLayout.tsx
import React from "react";
import { Outlet } from "react-router-dom";
import { Configuration } from "@/config";
import useJobEngineSignalR from "./useJobEngineSignalR";

const { config: { JOB_ENGINE_API_ENDPOINT, PCS_SOFTWARE_CUSTOMER_ID } } = new Configuration();

const JobEngineLayout: React.FC = () => {
  // Lifecycle only — each page renders its own header (with the connection badge)
  useJobEngineSignalR({
    apiBaseUrl: JOB_ENGINE_API_ENDPOINT,
    customerId: String(PCS_SOFTWARE_CUSTOMER_ID),
  });

  return <Outlet />;
};

export default JobEngineLayout;
